import {
  Breadcrumb,
  Button,
  message,
  PageHeader,
  Table,
  Popconfirm,
} from "antd";
import { CloseOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import { addressService, companyService } from "_services";
import TabMenu from "../TabMenu";
import { Auth } from "_helpers";

function List({ match }) {
  const { id } = match.params;
  const { path } = match;
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [company, setCompany] = useState({});

  useEffect(() => {
    getItems(id);

    /* companyService.getById(id).then((x) => {
      setCompany(x.content);
      setItems(
        x.content.addresses.filter((item) => item.addressType === "WAREHOUSE")
      );
    }); */
  }, []);

  const getItems = (companyId) => {
    setLoading(true);
    companyService
      .getById(companyId)
      .then((x) => {
        setCompany(x.content);
        setItems(
          x.content.addresses.filter((item) => item.addressType === "WAREHOUSE")
        );
        setLoading(false);
      })
      .catch((error) => {
        message.error(`${error}`);
        setLoading(false);
      });
    /* addressService
      .getAllByCompany(companyId)
      .then((x) => {
        setItems(x.content);
        setLoading(false);
      })
      .catch((error) => {
        message.error(`${error}`);
      }); */
  };

  const handleDelete = (addressId) => {
    addressService
      .delete(company.id, addressId)
      .then((x) => {
        message.success("Successfully deleted!");
        getItems(id);
      })
      .catch((error) => {
        message.error(`${error}`);
      });
  };

  const getAdditionalButtons = () => {
    let buttons = [];
    if (
      Auth.hasRole(Auth.getProfile(), ["SAU"]) &&
      company.companyType !== "STORE"
    ) {
      buttons.push(
        <Link to={`${path}/add`.replace(":id", id)} key="1">
          <Button>Add</Button>
        </Link>
      );
    }
    return buttons;
  };

  const columns = [
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
      /* render: (text, record) => {
        if (company.companyType !== "STORE") {
          return (
            <Link to={`${path}/${record.id}`.replace(":id", id)}>{text}</Link>
          );
        }
        return text;
      }, */
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "Area",
      dataIndex: "area",
      key: "area",
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => {
        return (
          <Popconfirm
            title="Are you sure to delete this item?"
            onConfirm={() => handleDelete(record.id)}
            disabled={!Auth.hasRole(Auth.getProfile(), ["SAU"])}
          >
            <CloseOutlined />
          </Popconfirm>
        );
      },
    },
  ];

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item href="/dashboard">
              <span>Dashboard</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item href="/companies">
              <span>Company Search</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item href={`/companies/${company.id}/summary`}>
              <span>Company: {company.code}</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>Store Addresses</span>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getAdditionalButtons()}
      >
        <Page inner>
          <TabMenu menu="store-addresses" id={id} />
          <Table
            bordered
            loading={loading}
            rowKey="id"
            size="small"
            columns={columns}
            dataSource={items}
            pagination={false}
          />
        </Page>
      </PageHeader>
    </div>
  );
}

export default List;
